import { render, staticRenderFns } from "./PosSetting.vue?vue&type=template&id=75c0d014&scoped=true&"
import script from "./PosSetting.vue?vue&type=script&lang=js&"
export * from "./PosSetting.vue?vue&type=script&lang=js&"
import style0 from "./PosSetting.vue?vue&type=style&index=0&id=75c0d014&prod&lang=css&"
import style1 from "./PosSetting.vue?vue&type=style&index=1&id=75c0d014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c0d014",
  null
  
)

export default component.exports